import { MeridiemOptions } from "@/src/constants/DateTimeConstants";
import { createStore } from "@/src/hooks/store/createStore";
import { OptionDefinition } from "@amzn/awsui-components-react/polaris/internal/components/option/interfaces";
import moment from "moment";

interface EventCreateStore {
  numParticipants: string;
  setNumParticipants: (numParticipants: string) => void;
  selectedDuration: string;
  setSelectedDuration: (selectedDuration: string) => void;
  eventDate: string;
  setEventDate: (eventDate: string) => void;
  eventTime: string;
  setEventTime: (eventTime: string) => void;
  selectedMeridiem: OptionDefinition;
  setSelectedMeridiem: (selectedMeridiem: OptionDefinition) => void;
  prompt: string;
  setPrompt: (prompt: string) => void;
  eventTimezone: OptionDefinition;
  setEventTimezone: (eventTimezone: OptionDefinition) => void;
  audienceType: OptionDefinition;
  setAudienceType: (audienceType: OptionDefinition) => void;
  privacyType: OptionDefinition;
  setPrivacyType: (privacyType: OptionDefinition) => void;
  reset: () => void;
}

export const useEventCreateStore = createStore<EventCreateStore>("", (set, get, store) => ({
  numParticipants: '2',
  setNumParticipants: (numParticipants: string) => set({ numParticipants }),
  selectedDuration: '4',
  setSelectedDuration: (selectedDuration: string) => set({ selectedDuration }),
  eventDate: '',
  setEventDate: (eventDate: string) => set({ eventDate }),
  eventTime: '',
  setEventTime: (eventTime: string) => set({ eventTime }),
  selectedMeridiem: moment().hours() > 12 ? MeridiemOptions.PM : MeridiemOptions.AM,
  setSelectedMeridiem: (selectedMeridiem: OptionDefinition) => set({ selectedMeridiem }),
  prompt: '',
  setPrompt: (prompt: string) => set({ prompt }),
  eventTimezone: { value: '' },
  setEventTimezone: (eventTimezone: OptionDefinition) => set({ eventTimezone }),
  audienceType: {value: ""},
  setAudienceType: (audienceType: OptionDefinition) => set({ audienceType }),
  privacyType: { value: "" },
  setPrivacyType: (privacyType: OptionDefinition) => set({ privacyType }),
  reset: () => set(store.getInitialState()),
}));